import React from 'react';
import { Link } from 'react-router-dom';

function BackToTop() {
  return (
    <Link to="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
      <i className="bi bi-arrow-up"></i>
    </Link>
  );
}

export default BackToTop;
